'use strict';

export function marquee(selector, speed = 10) {
  const marqueeContainer = document.querySelector(selector);
  if (!marqueeContainer) return;

  const marqueeContent = marqueeContainer.querySelector('.marquee__content');
  if (!marqueeContent) return;

  function duplicateItems() {
    const items = Array.from(marqueeContent.children);
    let totalWidth = 0;
    const containerWidth = marqueeContainer.offsetWidth;

    // Reset duplikatów
    marqueeContent.innerHTML = '';
    items.forEach(item => marqueeContent.appendChild(item.cloneNode(true)));

    // Duplikujemy elementy, aż wypełnią co najmniej 2x szerokość kontenera
    while (totalWidth < containerWidth * 2) {
      items.forEach(item => {
        const clonedItem = item.cloneNode(true);
        marqueeContent.appendChild(clonedItem);
        totalWidth += clonedItem.offsetWidth;
      });
    }

    // Reset animacji
    marqueeContent.style.animation = 'none';
    requestAnimationFrame(() => {
      marqueeContent.style.animation = `marquee-scroll ${speed}s linear infinite`;
    });
  }

  duplicateItems();
  window.addEventListener('resize', duplicateItems);
}
